const APIKey="5592689ebd4b89a75fb91ea29364276c";

const SECRET="749703f9ba2c47e2";

export {APIKey, SECRET};